(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["page-faq-content"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('op-faq');
    if (!root) return;

    var items = root.querySelectorAll('.op-faq__item');
    items.forEach(function (item) {
      var summary = item.querySelector('.op-faq__q');
      var content = item.querySelector('.op-faq__a');
      if (!summary || !content) return;

      function animateOpen() {
        var endHeight = content.scrollHeight;
        content.style.height = '0px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.42s cubic-bezier(0.22,1,0.36,1)';
        requestAnimationFrame(function () {
          content.style.height = endHeight + 'px';
        });
        content.addEventListener('transitionend', function handler() {
          content.style.height = '';
          content.style.overflow = '';
          content.style.transition = '';
          content.removeEventListener('transitionend', handler);
        });
      }

      function animateClose() {
        var startHeight = content.scrollHeight;
        content.style.height = startHeight + 'px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.42s cubic-bezier(0.22,1,0.36,1)';
        requestAnimationFrame(function () {
          content.style.height = '0px';
        });
        content.addEventListener('transitionend', function handler() {
          content.style.height = '';
          content.style.overflow = '';
          content.style.transition = '';
          item.removeAttribute('open');
          content.removeEventListener('transitionend', handler);
        });
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.hasAttribute('open')) {
          animateClose();
        } else {
          item.setAttribute('open', '');
          animateOpen();
        }
      });
    });

    var animEls = root.querySelectorAll('[data-faq-anim]');
    var list = root.querySelector('[data-faq-list]');

    if (!('IntersectionObserver' in window)) {
      animEls.forEach(function (el) { el.classList.add('is-in'); });
      if (list) list.classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    animEls.forEach(function (el) { io.observe(el); });
    if (list) io.observe(list);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatPrice(cents) {
      var kr = (cents / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return kr + ' kr';
    }

    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var openBtn = form.querySelector('[data-quick-open]');
      var panel = form.querySelector('[data-quick-panel]');
      if (!openBtn || !panel) return;

      var closeBtn = panel.querySelector('[data-quick-close]');
      var pills = panel.querySelectorAll('[data-quick-option-name]');
      var optionGroups = panel.querySelectorAll('[data-quick-option]');
      var priceDisplay = panel.querySelector('[data-quick-price-display]');
      var confirm = panel.querySelector('[data-quick-confirm]');
      var variantInput = form.querySelector('[data-quick-variant-input]');

      var variantsScript = panel.querySelector('[data-quick-variants]');
      var variants = [];
      if (variantsScript) {
        try { variants = JSON.parse(variantsScript.textContent); }
        catch (e) { variants = []; }
      }

      function getSelectedOptions() {
        var selected = [];
        optionGroups.forEach(function (group) {
          var active = group.querySelector('.is-selected');
          if (active) selected.push(active.dataset.quickOptionValue);
        });
        return selected;
      }

      function findVariant(selectedOptions) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (v.options[j] !== selectedOptions[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      function updateSelection() {
        var selectedOptions = getSelectedOptions();
        var variant = findVariant(selectedOptions);

        if (priceDisplay) priceDisplay.classList.add('is-updating');

        setTimeout(function () {
          if (variant) {
            if (variantInput) variantInput.value = variant.id;
            if (priceDisplay) priceDisplay.textContent = formatPrice(variant.price);
            if (confirm) {
              if (!variant.available) {
                confirm.disabled = true;
                var txt = confirm.querySelector('.ppc__quick-confirm-txt');
                if (txt) txt.textContent = form.dataset.tSoldout || 'Udsolgt';
              } else {
                confirm.disabled = false;
                var txt2 = confirm.querySelector('.ppc__quick-confirm-txt');
                if (txt2) txt2.textContent = form.dataset.tAdd || 'Tilføj til kurv';
              }
            }
          }
          if (priceDisplay) priceDisplay.classList.remove('is-updating');
        }, 140);
      }

      function openPanel() {
        panel.hidden = false;
        requestAnimationFrame(function () {
          panel.classList.add('is-open');
        });
        document.addEventListener('click', outsideClick, true);
        document.addEventListener('keydown', escClose);
      }

      function closePanel() {
        panel.classList.remove('is-open');
        document.removeEventListener('click', outsideClick, true);
        document.removeEventListener('keydown', escClose);
        setTimeout(function () {
          if (!panel.classList.contains('is-open')) panel.hidden = true;
        }, 500);
      }

      function outsideClick(e) {
        if (!form.contains(e.target)) closePanel();
      }

      function escClose(e) {
        if (e.key === 'Escape') closePanel();
      }

      openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPanel();
      });

      if (closeBtn) closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closePanel();
      });

      pills.forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          if (pill.classList.contains('is-disabled')) return;
          var group = pill.closest('[data-quick-option]');
          if (!group) return;
          group.querySelectorAll('.ppc__quick-pill').forEach(function (p) {
            p.classList.remove('is-selected');
            p.setAttribute('aria-checked', 'false');
          });
          pill.classList.add('is-selected');
          pill.setAttribute('aria-checked', 'true');
          updateSelection();
        });
      });

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (!confirm || confirm.classList.contains('is-loading') || confirm.disabled) return;
        confirm.classList.add('is-loading');
        var txtEl = confirm.querySelector('.ppc__quick-confirm-txt');
        var originalTxt = txtEl ? txtEl.textContent : '';
        if (txtEl) txtEl.textContent = form.dataset.tAdding || 'Tilføjer...';

        try {
          var response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantInput.value,
              quantity: 1
            })
          });
          if (!response.ok) throw new Error('Add to cart failed');
          var cart = await (await fetch('/cart.js')).json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

          if (txtEl) txtEl.textContent = form.dataset.tAdded || 'Tilføjet';
          confirm.classList.remove('is-loading');
          confirm.classList.add('is-success');

          setTimeout(function () {
            closePanel();
            setTimeout(function () {
              if (txtEl) txtEl.textContent = originalTxt;
              confirm.classList.remove('is-success');
            }, 520);
          }, 900);
        } catch (err) {
          if (txtEl) txtEl.textContent = form.dataset.tError || 'Fejl, prøv igen';
          setTimeout(function () {
            if (txtEl) txtEl.textContent = originalTxt;
            confirm.classList.remove('is-loading');
          }, 1800);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
